export const SET_IS_LINK_TRIGGERED = "SET_IS_LINK_TRIGGERED";

export const setIsLinkTriggered = (isLinkTriggered) => ({
  type: SET_IS_LINK_TRIGGERED,
  isLinkTriggered,
});
